export default __webpack_public_path__ + "static/media/apex.29f15591.jpg";